import { noop, get, isEmpty } from 'lodash';

// local dependencies
import { getStore } from 'store';
import { addUrls } from 'store/actions/addUrls';
import { addLabels } from 'store/actions/addLabels';

// get store
const store = getStore();

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { addLabelsAndUrlsOnStoreResolver } from 'resolvers/addLabelsAndUrlsOnStore';
 */
export const addLabelsAndUrlsOnStoreResolver = ( { response = {}, done = noop } = {} ) => {
	const urls = get( response, 'component.elements.urls', {} );
	const labels = get( response, 'component.elements.labels', {} );

	// add URLs
	if( !isEmpty( urls ) ) {
		store.dispatch( addUrls( urls ) );
	}

	// add labels
	if( !isEmpty( labels ) ) {
		store.dispatch( addLabels( labels ) );
	}

	done();
};
